function Diamond3(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M360 240 240 0 120 240v120l120 120 120-120V240z"></path></svg>
    )
}

export default Diamond3